<template>
    <v-container>
        <v-row v-if="getEgresos.length>0">
            <v-col class="d-flex justify-end">
                <v-btn color="teal" dark class="mb-2" @click="save" >
                    CREAR COMPROBANTE
                    </v-btn>
            </v-col>
        </v-row>
        <v-expansion-panels v-model="panel">
            <v-expansion-panel expand
            v-for="(item,i) in getEgresos"
            :key="i"
            >
            <v-expansion-panel-header color="light-green" class="white--text" @click="getPagoDetalles(item)" disable-icon-rotate>
                <v-row class="textcard">
                    <v-col>
                        <strong>Recibo: {{item.codigo}}</strong>  
                    </v-col>
                    <v-col>
                        <strong>Recibo: {{item.fechasolicitud}}</strong>  
                    </v-col>
                    <v-col cols="3">
                        <strong>Total: Q {{item.total}}</strong>  
                    </v-col>
                    <v-col>
                        <strong>{{item.estado}}</strong> 
                    </v-col>
                </v-row>
              <template v-slot:actions>
                  
                  <v-btn icon @click="deleteSwal(item)"> <v-icon color="light-green darken-4">mdi-trash-can</v-icon> </v-btn>
                  <v-divider vertical class="ml-2 mr-2" ></v-divider>
                  <v-btn icon> <v-icon color="light-green darken-4">mdi-menu-down</v-icon> </v-btn>
                    
                </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <PagoDetalle/>
            </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        
        <v-card v-show="getEgresos.length==0">
            <v-card-text class="text-h5 font-weight-bold text-center" >
                NO HAY COMPROBANTES CREADOS <br>
                <v-btn color="teal" dark class="mb-2" @click="save">
                    CREAR COMPROBANTE
                 </v-btn>

            </v-card-text>
            
        </v-card>
    </v-container>
</template>
<script>
import Swal from 'sweetalert2'
import dayjs from 'dayjs'
import PagoDetalle from '@/components/pagodetalle/PagoDetalle.vue'

export default {
    components:{
        PagoDetalle
    },
    data: () => ({
        panel:0,
        editedItem:{
            codigo: "ASE001",
            fechasolicitud: dayjs().format('YYYY-MM-DD'),
            fechaentrega: dayjs().format('YYYY-MM-DD'),
            anticipo: 0,
            total: 0,
            tipo: "EGRESO",
            estado: "Cancelado"
        },
        defaultItem:{
            codigo: "ASE001",
            fechasolicitud: dayjs().format('YYYY-MM-DD'),
            fechaentrega: dayjs().format('YYYY-MM-DD'),
            anticipo: 0,
            total: 0,
            tipo: "EGRESO",
            estado: "Cancelado"
        }
    }),
    async created(){
        this.$store.dispatch("setIdPersona",0)
        await this.$store.dispatch("getMediosPagos")
        await this.$store.dispatch("getCategorias")
        await this.$store.dispatch("getEgresos")

         this.codigoTransaccion()
         if(this.getEgresos[0]){
            await this.getPagoDetalles(this.getEgresos[0])
         }
         
    }, 
    computed:{
        getEgresos(){
        return this.$store.getters.getPagos;
        },
        formTitle() {
            return this.editedIndex === -1 ? 'Nuevo Registro' : 'Editar Registro';
        },
    },
     methods:{
        async getItems(){
                await this.$store.dispatch("getEgresos");
        },
        async getPagoDetalles(item){
            localStorage.setItem("idpago",item.idpago)
            await this.$store.dispatch("getPagoDetalles",item.idpago);
        },
        async postItem(){
            
            
            await  this.$store.dispatch("postPago",this.editedItem);
        },
        async putItem(){
            await this.$store.dispatch("putPago",this.editedItem);
        },
        editItem(item) {   
            this.dialog = true; 
            this.editedIndex = this.getEgresos.indexOf(item)       
            this.editedItem = Object.assign({}, item)
        },
        async deleteItem(id){
            await this.$store.dispatch("deletePago",id);
        },
        save () {
            this.parseNumber()
            if (this.editedIndex > -1) {
                 this.putItem();
            } else {
                this.postItem(); 
            }
            this.close()
        },
        async close(){  
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1
            })
        },
        deleteSwal(item){
            Swal.fire({
            title: 'Presione Sí para eliminar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText:'Cancelar',
            confirmButtonText: 'Sí'
            }).then((result) => {
            if (result.isConfirmed) {
                this.deleteItem(item.idpago);
            }
            })
        },
        parseNumber(){
            this.editedItem.total = parseFloat(this.editedItem.total)
            this.editedItem.anticipo = parseFloat(this.editedItem.anticipo)
        },
        //GenerarCodigo
        codigoTransaccion() {
            let result = "";
            let characters =
                "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
            for (let i = 0; i < 6; i++) {
                result += characters.charAt(
                Math.floor(Math.random() * characters.length)
                );
            }
            this.editedItem.codigo = result;
        },
    },
    filters:{
        formatoFecha: function (value) {
            if (!value) return ''
            return dayjs(value).format('DD-MM-YYYY')
        }
    }
}
</script>
<style scoped>
    .textcard{
        color: #263238;
    }
</style>